export function getEdgeBaseUrl(): string {
  const rawUrl =
    import.meta.env.VITE_SUPABASE_EDGE_URL ??
    import.meta.env.VITE_EDGE_URL ??
    'https://vicrmlrylwwyzhxnkkhn.supabase.co/functions/v1';

  return rawUrl.replace(/\/$/, '');
}

export function buildEdgeUrl(path: string): string {
  const base = getEdgeBaseUrl();
  const normalizedPath = path.replace(/^\//, '');
  return `${base}/${normalizedPath}`;
}
